import * as React from 'react'
import { Modal } from 'antd'

import Styles from './InfoModal.module.scss'
import { Button } from 'blaze-ui/Button'

interface Props {
  visible: boolean
  children?: React.ReactNode
  setVisible: (visible: boolean) => void
  title: string
  onCancel?: () => void
  onOk?: () => boolean
  okText?: string
  cancelText?: string
  hideCancel?: boolean
  actionsDisabled?: boolean
}

const InfoModal = ({
  visible,
  setVisible,
  title,
  onCancel,
  onOk,
  children,
  okText,
  cancelText,
  hideCancel,
  actionsDisabled,
}: Props) => {
  const onHide = () => {
    setVisible(false)
    if (onCancel) onCancel()
  }

  const onConfirm = () => {
    if (onOk) {
      setVisible(!onOk())
    } else {
      setVisible(false)
    }
  }

  return (
    <Modal visible={visible} onCancel={onHide} footer={null} onOk={onConfirm} closable={false}>
      <div>
        <div className={Styles.title}>{title}</div>
        <div className={Styles.content}>{children}</div>
        <div className={Styles.footer}>
          {!hideCancel && (
            <Button size="md" onPress={onHide} variant="secondary" data-testid="cancel" isDisabled={actionsDisabled}>
              {cancelText ? cancelText : 'Cancel'}
            </Button>
          )}
          <Button onPress={onConfirm} size="md" data-testid="confirm" isDisabled={actionsDisabled}>
            {okText ? okText : 'Ok'}
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default InfoModal
